var DEFAULT_BUTTON_COLOR = '#FF45C3';
var DEFAULT_CONTENT_COLOR = 'white';

export { DEFAULT_BUTTON_COLOR, DEFAULT_CONTENT_COLOR };
